import { styled } from "styled-components";

import { LinkButton } from "@vericus/cadmus-ui";

export const StyledLinkButton = styled(LinkButton)`
  font-weight: 600;
`;
